<template>
  <section class="edusources-container main new-header">
    <div v-if="!communityData.translation && isReady">
      <error status-code="404" message-key="community-not-found" />
    </div>
    <CommunityDesktop
      v-else-if="communityData.translation && !$vuetify.breakpoint.mobile && isReady"
      :key="`${communityData.metadata.id}-${$i18n.locale}`"
      :community-data="communityData"
      :on-community-search="goToCommunitySearch"
    />
    <CommunityMobile
      v-else-if="communityData.translation && $vuetify.breakpoint.mobile && isReady"
      :key="`mb-${communityData.metadata.id}-${$i18n.locale}`"
      :community-data="communityData"
      :on-community-search="goToCommunitySearch"
    />
  </section>
</template>

<script>
import isUUID from "is-uuid";
import { mapGetters } from "vuex";
import Error from "~/components/error";
import PageMixin from "~/pages/page-mixin";
import CommunityDesktop from "@/pages/communities/community.desktop";
import CommunityMobile from "@/pages/communities/community.mobile";

export default {
  name: "Community",
  components: {
    Error,
    CommunityDesktop,
    CommunityMobile,
  },
  mixins: [PageMixin],
  computed: {
    ...mapGetters(["user"]),
    communityData() {
      return {
        collections: this.$store.getters.getPublicCollections(this.user),
        metadata: this.$store.getters.getCommunityInfo(this.user) || null,
        translation: this.$store.getters.getCommunityTranslation(this.user, this.$i18n.locale),
        dynamic_collections: this.$store.getters.getStoredCommunityDynamicCollections(),
      };
    },
  },
  created() {
    const { community } = this.$route.params;
    this.pageLoad = Promise.all([
      this.$store.dispatch("getCommunity", community),
      this.$store.dispatch("getCommunityCollections", community),
    ]).then(() => {
      if (isUUID.v4(community)) {
        this.$router.push(
          this.localePath({
            name: "communities-community",
            params: { community: this.communityData.metadata.slug },
          })
        );
        location.reload();
      }
      this.$store.dispatch("getCommunityDynamicCollections", this.communityData.metadata.id);
    });
  },
  metaInfo() {
    const defaultTitle = this.$root.$meta().title;
    return {
      title: this.communityData.translation ? this.communityData.translation.title || defaultTitle : defaultTitle,
    };
  },
  methods: {
    goToCommunitySearch() {
      let domain = location.origin.replace("search.", "");
      if (location.href.includes("localhost")) {
        domain = process.env.VUE_APP_LOCAL_SEARCH_DOMAIN;
      }
      const searchUrl = `${domain}/materials/search/?&filters=[{"external_id":"consortium.keyword","items":["${encodeURIComponent(
        this.communityData.metadata.publisher
      )}"]}]`;
      window.location.href = searchUrl;
    },
  },
};
</script>
